import { render, staticRenderFns } from "./bill-report.vue?vue&type=template&id=52991877&scoped=true&"
import script from "./bill-report.vue?vue&type=script&lang=js&"
export * from "./bill-report.vue?vue&type=script&lang=js&"
import style0 from "./bill-report.vue?vue&type=style&index=0&id=52991877&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52991877",
  null
  
)

export default component.exports